import { useContext } from "react";
import ServiceAuthContext from "auth/ServiceAuthContext";

const useServiceAuth = () => useContext(ServiceAuthContext);

export default useServiceAuth;
